import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import { Inter, Poppins } from 'next/font/google'

import { AuthProvider } from '@/components/auth-provider'
import Navbar from '@/components/navbar'
import { Footer } from '@/components/footer'
import { Toaster as SonnerToaster } from '@/components/ui/sonner'
import { useHydrateLogoState } from '@/lib/use-logo-state'

const inter = Inter({
    subsets: ['latin'],
    variable: '--font-sans',
    display: 'swap'
})

const display = Poppins({
    subsets: ['latin'],
    // Poppins is not a variable face, so the weights the system uses ship explicitly.
    weight: ['400', '500', '600', '700'],
    variable: '--font-display',
    display: 'swap'
})

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    // Reads the visitor's saved draft back out of the browser after mount.
    useHydrateLogoState()

    return (
        <div className={`${inter.variable} ${display.variable} font-sans antialiased`}>
            <AuthProvider>
                <div className='flex min-h-screen flex-col bg-paper'>
                    <Navbar />
                    <main className='flex-1'>
                        <Component {...pageProps} />
                    </main>
                    <Footer />
                </div>
                <SonnerToaster />
            </AuthProvider>
        </div>
    )
}

export default App
